import { Routes } from '@angular/router';
import { LoginComponent } from './modules/login/login.component';
import { LocalizationComponent } from './modules/localization/localization.component';
import { ComparativeObjectComponent } from './modules/comparative-object/comparative-object.component';
import { AdvancedComponent } from './modules/advanced/advanced.component';
import { AdminComponent } from './modules/admin/admin.component';
import { adminGuard, authGuard, loginGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', component: LoginComponent, canActivate: [loginGuard] },
  { path: 'localization', component: LocalizationComponent, canActivate: [authGuard] },
  { path: 'comparative-object', component: ComparativeObjectComponent, canActivate: [authGuard] },
  { path: 'advanced', component: AdvancedComponent, canActivate: [authGuard] },
  { path: 'admin', component: AdminComponent, canActivate: [adminGuard] }
];
